
import {errorHandler} from "./errorHandler";
import {responses} from "./responses";
// window.pay = `http://192.168.1.222:8080/Lyt-SoftBackOfficeApi/`
window.pay = `https://realtime.abc.co.zm:8443/Lyt-SoftBackOfficeApi/`

window.synergyApi=`https://lna.abc.co.zm/SynergyApi/api/v1/`
// window.synergyApi=`http://192.168.1.222:8181/SynergyApi/api/v1/`


window.errorHandler = errorHandler;
window.responses = responses;
